import React from 'react';
import { whatWeDo, stats } from '../mock';
import { GitBranch, ScanText, FileBadge2 } from 'lucide-react';

const Icons = [GitBranch, ScanText, FileBadge2];

export default function WhatWeDo() {
  return (
    <section id="what" className="relative">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10 py-20 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-5">
            <div className="text-[11.5px] tracking-[0.16em] uppercase text-[#1B6F5E] font-medium">
              What ESGine® does
            </div>
            <h2 className="mt-3 font-display text-[40px] lg:text-[56px] leading-[1.02] text-[#0B1F2D]">
              Compliance, not
              <br />
              <span className="italic text-[#1B6F5E]">commentary.</span>
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-3">
            <p className="text-[16.5px] leading-[1.6] text-[#0B1F2D]/70 max-w-[640px]">
              ESGine® is the world’s only ESG-as-Code® compliance platform. Upload your ESG report and receive a
              clause-by-clause compliance result across seven frameworks and 90+ rules. Every outcome maps to a specific
              regulatory clause. Not a score. The law.
            </p>
          </div>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {whatWeDo.map((c, i) => {
            const Ico = Icons[i];
            return (
              <div
                key={c.title}
                className="card-lift rounded-2xl border border-[#E8E5DC] bg-white p-7 lg:p-8 group"
              >
                <div className="w-11 h-11 rounded-xl bg-[#E8F3EE] flex items-center justify-center text-[#1B6F5E] mb-6">
                  <Ico className="w-5 h-5" />
                </div>
                <div className="font-display text-[22px] leading-[1.15] text-[#0B1F2D]">{c.title}</div>
                <p className="mt-3 text-[14px] leading-[1.6] text-[#0B1F2D]/65">{c.desc}</p>
                <div className="mt-6 pt-5 border-t border-[#E8E5DC] flex items-center justify-between text-[12px] text-[#0B1F2D]/55">
                  <span className="font-mono-tight">0{i + 1}</span>
                  <span className="tracking-[0.12em] uppercase">{['Logic', 'AI + Code', 'Audit'][i]}</span>
                </div>
              </div>
            );
          })}
        </div>

        {/* Stats strip */}
        <div className="mt-16 lg:mt-20 grid grid-cols-2 md:grid-cols-4 gap-px bg-[#E8E5DC] rounded-2xl overflow-hidden border border-[#E8E5DC]">
          {stats.map((s) => (
            <div key={s.label} className="bg-[#FAFAF5] px-6 py-8 lg:py-10">
              <div className="font-display text-[44px] lg:text-[56px] leading-none text-[#0B1F2D]">{s.value}</div>
              <div className="mt-2 text-[12.5px] text-[#0B1F2D]/60">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
